import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a74257b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "meeting-info" }
const _hoisted_2 = { class: "meeting-name" }
const _hoisted_3 = { class: "meeting-time" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chevron" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "admin-settings",
  ref: "PopUpButtonRef"
}
const _hoisted_6 = { class: "invite-wrap" }
const _hoisted_7 = { class: "settings-title invite" }
const _hoisted_8 = { class: "settings-description" }
const _hoisted_9 = {
  key: 0,
  class: "files-wrap"
}
const _hoisted_10 = { class: "title-wrap" }
const _hoisted_11 = { class: "settings-title" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "text-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DownloadedFiles = _resolveComponent("DownloadedFiles")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["meeting-wrap", {'active': _ctx.isActive}]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args))),
      ref: "PopUpRef"
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.name), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.time), 1),
      _hoisted_4
    ], 2),
    _createVNode(_Transition, { name: "admin-settings" }, {
      default: _withCtx(() => [
        (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.t('invitePeople.title')), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t('invitePeople.description')), 1),
                _createVNode(_component_Input, {
                  class: "copy-link",
                  id: "copy",
                  type: "copy",
                  modelValue: _ctx.link,
                  ref: "input"
                }, null, 8, ["modelValue"])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h3", _hoisted_11, [
                        _createTextVNode(_toDisplayString(_ctx.t('fileInput.attached')), 1),
                        (!_ctx.isEmpty)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(`(${_ctx.count})`), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.isEmpty)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            size: "s",
                            mode: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('fileInput.delete')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isEmpty)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.t('fileInput.noFiles')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.isEmpty)
                      ? (_openBlock(), _createBlock(_component_DownloadedFiles, { key: 1 }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}